export default class Isolate {
  private element: HTMLElement;
  private affectedHiddenElements: HTMLElement[];
  private affectedInertElements: HTMLElement[];

  constructor(el: HTMLElement) {
    if (typeof HTMLElement === 'undefined' || !(el instanceof HTMLElement)) {
      throw new Error(
        'Isolate must be instantiated with a valid HTML element'
      );
    }

    this.element = el;
    this.affectedHiddenElements = [];
    this.affectedInertElements = [];
  }

  /**
   * applies 'aria-hidden' and 'inert' to everything except direct parents of 'this.element'
   */
  activate() {
    let parent = this.element.parentNode;

    while (parent && parent.nodeName !== 'HTML') {
      Array.prototype.slice
        .call(parent.children)
        .forEach((child: HTMLElement) => {
          if (child !== this.element && !child.contains(this.element)) {

            if (child.getAttribute('aria-hidden') !== 'true') {
              this.affectedHiddenElements.push(child);
              child.setAttribute('aria-hidden', 'true');
            }

            if(!child.hasAttribute('inert')) {
              this.affectedInertElements.push(child);
              child.setAttribute('inert', 'true');
            }
          }
        });

      parent = parent.parentNode;
    }
  }

  /**
   * restores 'aria-hidden' and 'inert' states by removing the attributes
   * from everything affected by 'activate'
   */
  deactivate() {

    this.affectedHiddenElements.forEach((affected) => {
      affected.removeAttribute('aria-hidden');
    });

    this.affectedInertElements.forEach((affected) => {
      affected.removeAttribute('inert');
    });

    this.affectedHiddenElements = [];
    this.affectedInertElements = [];
  }
}
